import ApiService from './ApiService.js'

export default {
  get (culture) {
    return ApiService.get('crops/properties', culture)
  }
}
